// extracted by mini-css-extract-plugin
export default {"label":"item_label_label__8zvQn"};